import api from './api';

/**
 * Servicio para gestionar autenticación de usuarios
 */
export const authService = {
  /**
   * Inicia sesión de un usuario
   * @param {Object} credentials - Credenciales de acceso
   * @param {string} credentials.email - Email del usuario
   * @param {string} credentials.password - Contraseña
   * @returns {Promise<Object>} Datos del usuario y token
   */
  login: async (credentials) => {
    try {
      const response = await api.post('/usuarios/login', credentials);
      
      // Guardar token en localStorage
      if (response.data?.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.usuario));
      }
      
      return response.data;
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      throw error;
    }
  },

  /**
   * Registra un nuevo usuario
   * @param {Object} userData - Datos del nuevo usuario
   * @param {string} userData.nombre - Nombre completo
   * @param {string} userData.email - Email
   * @param {string} userData.password - Contraseña
   * @param {string} userData.institucion - Institución educativa
   * @returns {Promise<Object>} Usuario registrado
   */
  register: async (userData) => {
    try {
      const response = await api.post('/usuarios/register', userData);
      
      // Auto-login después del registro
      if (response.data?.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.usuario));
      }
      
      return response.data;
    } catch (error) {
      console.error('Error al registrar usuario:', error);
      throw error;
    }
  },

  /**
   * Cierra sesión del usuario actual
   */
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  /**
   * Obtiene el usuario actual del localStorage
   * @returns {Object|null} Usuario actual o null
   */
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch (error) {
      console.error('Error al parsear usuario:', error);
      return null;
    }
  },

  /**
   * Verifica si hay un token válido
   * @returns {boolean} True si hay token
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  /**
   * Obtiene el token actual
   * @returns {string|null} Token o null
   */
  getToken: () => {
    return localStorage.getItem('token');
  },
};

export default authService;
